import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import localizations from the new flattened structure
import loginEn from './locales/guest/en/login.json';
import registerEn from './locales/guest/en/register.json';
import errorsEn from './locales/guest/en/errors.json';
import apiErrorsEn from './locales/guest/en/api_errors.json';
import verificationEn from './locales/guest/en/guest_verification.json';
import forgotPasswordEn from './locales/guest/en/forgot_password.json';
import onboardingEn from './locales/guest/en/onboarding.json';
import dashboardEn from './locales/app/en/dashboard.json';
import navigationEn from './locales/app/en/navigation.json';
import profileEn from './locales/app/en/profile.json';
import pagesEn from './locales/app/en/pages.json';
import roadmapEn from './locales/app/en/roadmap.json';
import adminDashboardEn from './locales/admin/en/dashboard.json';
import adminNavigationEn from './locales/admin/en/navigation.json';
import adminUsersEn from './locales/admin/en/users.json';
import adminResourcesEn from './locales/admin/en/resources.json';
import adminAnalysisEn from './locales/admin/en/analysis.json';
import adminReportsEn from './locales/admin/en/reports.json';
import adminSchoolsEn from './locales/admin/en/schools.json';
import adminPlatformSettingsEn from './locales/admin/en/platform_settings.json';
import fileUploadEn from './locales/sharedComponent/fileUpload/en/api.json';
import appSharedEn from './locales/sharedComponent/Modal/en/shared.json';
import schoolDashboardEn from './locales/school/en/dashboard.json';
import parentEn from './locales/app/en/parent.json';
import calendarEn from './locales/app/en/calendar.json';


import loginAr from './locales/guest/ar/login.json';
import registerAr from './locales/guest/ar/register.json';
import errorsAr from './locales/guest/ar/errors.json';
import apiErrorsAr from './locales/guest/ar/api_errors.json';
import verificationAr from './locales/guest/ar/guest_verification.json';
import forgotPasswordAr from './locales/guest/ar/forgot_password.json';
import onboardingAr from './locales/guest/ar/onboarding.json';
import dashboardAr from './locales/app/ar/dashboard.json';
import navigationAr from './locales/app/ar/navigation.json';
import profileAr from './locales/app/ar/profile.json';
import pagesAr from './locales/app/ar/pages.json';
import roadmapAr from './locales/app/ar/roadmap.json';
import adminDashboardAr from './locales/admin/ar/dashboard.json';
import adminNavigationAr from './locales/admin/ar/navigation.json';
import adminUsersAr from './locales/admin/ar/users.json';
import adminResourcesAr from './locales/admin/ar/resources.json';
import adminAnalysisAr from './locales/admin/ar/analysis.json';
import adminReportsAr from './locales/admin/ar/reports.json';
import adminSchoolsAr from './locales/admin/ar/schools.json';
import adminPlatformSettingsAr from './locales/admin/ar/platform_settings.json';
import fileUploadAr from './locales/sharedComponent/fileUpload/ar/api.json';
import appSharedAr from './locales/sharedComponent/Modal/ar/shared.json';
import schoolDashboardAr from './locales/school/ar/dashboard.json';
import parentAr from './locales/app/ar/parent.json';
import calendarAr from './locales/app/ar/calendar.json';


const resources = {
  en: {
    guest_login: loginEn,
    guest_register: registerEn,
    guest_errors: errorsEn,
    guest_api_errors: apiErrorsEn,
    guest_verification: verificationEn,
    guest_forgot_password: forgotPasswordEn,
    guest_onboarding: onboardingEn,
    api_errors: apiErrorsEn,
    app_dashboard: dashboardEn,
    app_navigation: navigationEn,
    app_profile: profileEn,
    app_pages: pagesEn,
    app_roadmap: roadmapEn,
    admin_dashboard: adminDashboardEn,
    admin_navigation: adminNavigationEn,
    admin_users: adminUsersEn,
    admin_resources: adminResourcesEn,
    admin_analysis: adminAnalysisEn,
    admin_schools: adminSchoolsEn,
    admin: {
      dashboard: adminDashboardEn,
      navigation: adminNavigationEn,
      users: adminUsersEn,
      resources: adminResourcesEn,
      analysis: adminAnalysisEn,
      reports: adminReportsEn,
      schools: adminSchoolsEn,
      platform_settings: adminPlatformSettingsEn,
    },
    file_upload: fileUploadEn,
    app_shared: appSharedEn,
    school_dashboard: schoolDashboardEn,
    app_parent: parentEn,
    app_calendar: calendarEn,

  },
  ar: {
    guest_login: loginAr,
    guest_register: registerAr,
    guest_errors: errorsAr,
    guest_api_errors: apiErrorsAr,
    guest_verification: verificationAr,
    guest_forgot_password: forgotPasswordAr,
    guest_onboarding: onboardingAr,
    api_errors: apiErrorsAr,
    app_dashboard: dashboardAr,
    app_navigation: navigationAr,
    app_profile: profileAr,
    app_pages: pagesAr,
    app_roadmap: roadmapAr,
    admin_dashboard: adminDashboardAr,
    admin_navigation: adminNavigationAr,
    admin_users: adminUsersAr,
    admin_resources: adminResourcesAr,
    admin_analysis: adminAnalysisAr,
    admin_schools: adminSchoolsAr,
    admin: {
      dashboard: adminDashboardAr,
      navigation: adminNavigationAr,
      users: adminUsersAr,
      resources: adminResourcesAr,
      analysis: adminAnalysisAr,
      reports: adminReportsAr,
      schools: adminSchoolsAr,
      platform_settings: adminPlatformSettingsAr,
    },
    file_upload: fileUploadAr,
    app_shared: appSharedAr,
    school_dashboard: schoolDashboardAr,
    app_parent: parentAr,
    app_calendar: calendarAr,

  },
};

const namespaces = [
  'guest_login', 'guest_register', 'guest_errors', 'guest_api_errors', 'api_errors',
  'guest_verification', 'guest_forgot_password', 'app_dashboard', 
  'app_navigation', 'app_profile', 'app_pages', 'app_roadmap', 'admin_dashboard',
  'admin_navigation', 'admin_users', 'admin_resources', 'admin_analysis', 'admin_schools', 'admin',
  'file_upload', 'app_shared', 'school_dashboard', 'app_parent', 'app_calendar'
];

const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
let queryLng = searchParams?.get('lng') || searchParams?.get('lang');

// Also check pathname for shorthand =en or =ar (e.g. /login=en)
if (!queryLng && typeof window !== 'undefined') {
  const match = window.location.pathname.match(/=(en|ar)(?:$|\/)/i);
  if (match) {
    queryLng = match[1].toLowerCase();
  }
}

if (queryLng && (queryLng === 'en' || queryLng === 'ar')) {
  try {
    localStorage.setItem('i18nextLng', queryLng);
  } catch {}
}

const savedLng = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
const initialLng = (queryLng === 'en' || queryLng === 'ar') ? queryLng : (savedLng || 'ar');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng, // default language
    fallbackLng: 'ar',
    ns: namespaces,
    defaultNS: 'guest_login',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// Handle global RTL/LTR direction
const updateDirection = (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
};

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
  updateDirection(lng);
});

// Initial check
updateDirection(i18n.language);

export default i18n;

